export const black = "black";
export const background = "#fafafa";
export const border = "#c7c7c7";
export const blue = "#228be6";
